export const APPLE_PAY_BUTTON_ID = 'apple-pay-button';
